module.exports = __webpack_public_path__ + "img/icon-worker-3.05d9c217.svg";